import { render, staticRenderFns } from "./btn-secondary.vue?vue&type=template&id=0bb6a00c&scoped=true&"
import script from "./btn-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6a00c",
  null
  
)

export default component.exports